import {
  FunctionComponent,
  PropsWithChildren,
  ReactNode,
  useEffect,
} from "react";

import { cycloneCommentsService } from "@framework/comments/CycloneCommentsService";
import CycloneCommentsContext from "@voxmedia/duet-context/context/cyclone-comments-context";

interface Props {
  children?: ReactNode;
}

/**
 * Comment counts only for Cyclone communities (feeds, cards, lede meta, etc.).
 * Mounted app-wide when a community has cyclone enabled.
 *
 * Not to be confused with `@framework/cyclone/providers/CycloneProvider`, which
 * powers fanposts, viewer auth, and Cyclone platform data on SB Nation.
 */
const CycloneCommentsProvider: FunctionComponent<PropsWithChildren<Props>> = ({
  children,
}) => {
  useEffect(() => {
    cycloneCommentsService
      .loadAllCountsFromIndexedDB()
      .catch((error: unknown) => {
        console.warn("Failed to load comment counts from IndexedDB:", error);
      });
  }, []);

  return (
    <CycloneCommentsContext.Provider value={cycloneCommentsService}>
      {children}
    </CycloneCommentsContext.Provider>
  );
};

export default CycloneCommentsProvider;
